<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  direction: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

// Message#message_type enum (app/models/message.rb): incoming, outgoing,
// activity, template.
const DIRECTION_CONFIG = {
  incoming: { icon: 'i-lucide-arrow-down-left', class: 'text-n-slate-11' },
  outgoing: { icon: 'i-lucide-arrow-up-right', class: 'text-n-slate-11' },
  activity: { icon: 'i-lucide-info', class: 'text-n-slate-10' },
  template: { icon: 'i-lucide-file-text', class: 'text-n-slate-10' },
};

const config = computed(
  () => DIRECTION_CONFIG[props.direction] || DIRECTION_CONFIG.activity
);
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 text-body-main whitespace-nowrap"
    :class="config.class"
  >
    <Icon :icon="config.icon" class="size-3.5 shrink-0" />
    <span>{{
      t(`MESSAGE_LOGS_PAGE.DIRECTION.${direction.toUpperCase()}`)
    }}</span>
  </span>
</template>
